import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, Paper, Tabs, Tab, Grid} from '@material-ui/core'
import {compose} from 'redux'
import Page from 'src/shared/Page/Page'
import autobind from 'autobind-decorator'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { TransactionCriteria } from 'src/type/criteria/transactionCriteria'
import { fetchTransactionsChange, fetchTransactionsDette, fetchTransactionsPlacement, getDocumentRelateTransaction } from 'src/core/redux/action/transactionsAction'
import TransactionsChange from 'src/page/Consumer/Transactions/tabs/TransactionsChange'
import TransactionsPlacement from 'src/page/Consumer/Transactions/tabs/TransactionsPlacement'
import TransactionsDette from 'src/page/Consumer/Transactions/tabs/TransactionsDette'
import Alert from 'src/shared/Alert/Alert'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'
import {css} from 'src/conf/style'
import PageTitle from 'src/shared/PageTitle/PageTitle'
import { IModal, ModalType } from 'src/type/modal'
import { ModalAction } from 'src/core/redux/action/modalActions'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import Documents from './documents/Documents'
import { PaginateAction } from 'src/core/redux/action/paginateAction'
import { fetchDocToSign, fetchDocSigned, fetchOtherDoc } from 'src/core/redux/action/transactionsAction'

const styles = (t: Theme) => createStyles({
    root: {
        position: 'relative',
        flexGrow: 1,
        padding: t.spacing.unit * 4,
        backgroundColor: t.palette.background.paper,
    },
    tabsRoot: {
        marginBottom: t.spacing.unit * 2,
        borderBottom: '1px solid #e8e8e8'
    },
    tabsIndicator: {
        backgroundColor: t.palette.primary.main
    },
    tabRoot: {
        textTransform: 'initial',
        minWidth: 72,
        fontWeight: t.typography.fontWeightRegular,
        marginRight: t.spacing.unit * 4,
        '&:hover': {
            color: t.palette.primary.main,
            opacity: 1,
        },
        '&$tabSelected': {
            color: t.palette.primary.main,
            fontWeight: t.typography.fontWeightMedium,
        },
        '&:focus': {
            color: t.palette.primary.main,
        },
    },
    tabSelected: {

    },
    tabLbl: {
        ...css.flexFullCenter
    },
    badge: {
        borderRadius: '4px',
        color: t.palette.common.white,
        background: t.palette.primary.main,
        marginLeft: '.75rem',
        minWidth: '20px'
    },
    badge2: {
        borderRadius: '4px',
        color: t.palette.common.white,
        background: 'rgb(63,81,181)',
        marginLeft: '.75rem',
        minWidth: '20px'
    }
});

interface IProps extends WithStyles<typeof styles>,
  WithI18n,
  WithToast,
  WithGlobalProgress,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
}

interface IStates {
    tabActive: string;
}

class Transactions extends React.Component<IProps, IStates> {
    state = {
        tabActive: undefined,
    };

  render(){
    const { enterprise, t, classes, transactionsChange, transactionsDette, transactionsPlacement} = this.props;
    const { tabActive } = this.state;
    const commonProps = {
        accessDocuments: this.accessDocuments
    }
    return(
        <>
            <HelmetMeta title={t.App_title_page_Transactions}/>
            <PageTitle title={t.operations} icon="account_balance" />
            
            <Page width="80%">
                <Paper className={classes.root}>
                    {enterprise.habilitations.length === 0 && 
                        <Alert type="warning">{t.transactions_alert_habilitations}</Alert>
                    }
                    {enterprise.habilitations.length > 0 && 
                        <>
                            {transactionsChange && transactionsDette && transactionsPlacement &&
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Tabs
                                        value={tabActive}
                                        onChange={this.handleChange}
                                        classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                                        scrollable scrollButtons="off"
                                        >
                                            {this.getAccessibleTabs().map(h => {
                                                const {label, size} = this.renderInfoTab(h);
                                                return (<Tab
                                                        key={`tab-${label}`}
                                                        disableRipple
                                                        classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                                        label={
                                                            <div className={classes.tabLbl}>
                                                                {label}
                                                                <div className={classes.badge}>{size}</div>
                                                            </div>
                                                        }
                                                        value={h}
                                                    />)
                                                }
                                            )}
                                        </Tabs>
                                        
                                        {tabActive === "change" && <TransactionsChange {...commonProps} />}
                                        {tabActive === "dette" && <TransactionsDette {...commonProps} />}
                                        {tabActive === "placement" && <TransactionsPlacement {...commonProps} />}
                                    </Grid>
                                </Grid>
                            }
                        </>
                    }
                </Paper>
            </Page>
       </>
    )
  }

  @autobind 
  private getAccessibleTabs() {
    const {enterprise} = this.props;
    if(!!enterprise.category_partenaire_btob && enterprise.category_partenaire_btob.includes('distributeur')) {
        if(enterprise.habilitations.includes("placement")) {
            return ["placement"]
        } else {
            return enterprise.habilitations.split(',').sort()
        }
    } else {
        return enterprise.habilitations.split(',').sort()
    }
  }

  @autobind
  private handleChange(event, value) {
    this.setState({ tabActive: value });
  };

  setDefaultTab = () => {
    const {enterprise} = this.props;
    if(enterprise.habilitations && enterprise.habilitations.length > 0) {
        this.setState({ tabActive: enterprise.habilitations.split(",").sort()[0] });
    }
  }

  componentDidMount(){
    const {promisesWithProgress, transactionsChangeCriteria, transactionsDetteCriteria, transactionsPlacementCriteria} = this.props;
    this.setDefaultTab();
    promisesWithProgress(
        this.props.fetchChange(transactionsChangeCriteria),
        this.props.fetchDette(transactionsDetteCriteria),
        this.props.fetchPlacement(transactionsPlacementCriteria)
    )
  }

  componentDidUpdate(prevPros){
    const {enterprise} = this.props;
      if(enterprise && enterprise !== prevPros.enterprise){
        this.setDefaultTab();
      }
  }

  renderInfoTab = (tabType) => {
    const {transactionsChangeSize, transactionsDetteSize, transactionsPlacementSize, t} = this.props;
    const tabs = {
        change:     {label: t.Transactions.first_tab, size: transactionsChangeSize}, 
        dette:      {label: t.Transactions.second_tab, size: transactionsDetteSize}, 
        placement:  {label: t.Transactions.third_tab, size: transactionsPlacementSize}, 
    }
    return tabs[tabType];
  }

  renderModalDocuments = (transaction) => <Documents {...{transaction}}/>

  closeModalAccessDocument = () => {
      const {closeModal, resetCriteriaOtherDoc, resetCriteriaDocToSign, resetCriteriaDocSigned} = this.props;
      resetCriteriaOtherDoc();
      resetCriteriaDocToSign();
      resetCriteriaDocSigned();
      closeModal();
  }

    // tslint:disable: no-empty
  accessDocuments = (transaction) => {
      const { t, openModal } = this.props
      openModal({
        type: ModalType.REVIEW,
        maxWidth: "lg",
        onClose: this.closeModalAccessDocument,
        onSubmit: () => {},
        title: t.Transactions.modal.helper_info_transaction(transaction.transaction.numero_du_contrat),
        content: this.renderModalDocuments(transaction),
        actionPosition: "center",
        cancelLabel: t.back
      } as IModal)
  }
}

const state2props = (state: RootState) => ({
    enterprise: state.accountInfo.enterpriseSelected,
    connectedUser: state.accountInfo.connectedUser,

    transactionsChange: state.paginate.transactionsChange.entities,
    transactionsChangeCriteria: state.paginate.transactionsChange.criteria,
    transactionsChangeSize: state.paginate.transactionsChange.total_size,
    
    transactionsDette: state.paginate.transactionsDette.entities,
    transactionsDetteCriteria: state.paginate.transactionsDette.criteria,
    transactionsDetteSize: state.paginate.transactionsDette.total_size,

    transactionsPlacement: state.paginate.transactionsPlacement.entities,
    transactionsPlacementCriteria: state.paginate.transactionsPlacement.criteria,
    transactionsPlacementSize: state.paginate.transactionsPlacement.total_size,
});

const actionsOtherDoc = new PaginateAction<any>('docNotToSign', fetchOtherDoc)
const actionsDocToSign = new PaginateAction<any>('docToSign', fetchDocToSign)
const actionsDocSigned = new PaginateAction<any>('signatures', fetchDocSigned)

const dispatch2props = dispatch => ({
    fetchChange: (c?: TransactionCriteria) => dispatch(fetchTransactionsChange(c)),
    fetchDette: (c?: TransactionCriteria) => dispatch(fetchTransactionsDette(c)),
    fetchPlacement: (c?: TransactionCriteria) => dispatch(fetchTransactionsPlacement(c)),
    openModal: (modal?: IModal) => dispatch(ModalAction.openModal(modal)),
    closeModal: () => dispatch(ModalAction.closeModal()),
    getDocuments: (transactionId: string) => dispatch(getDocumentRelateTransaction(transactionId)),
    
    resetCriteriaOtherDoc: () => dispatch(actionsOtherDoc.resetCriteria()),
    resetCriteriaDocToSign: () => dispatch(actionsDocToSign.resetCriteria()),
    resetCriteriaDocSigned: () => dispatch(actionsDocSigned.resetCriteria())
});


export default compose(
  withI18n,
  withGlobalProgress,
  withToast,
  connect(state2props, dispatch2props),
  withStyles(styles)
)(Transactions)



// WEBPACK FOOTER //
// ./src/page/Consumer/Transactions/Transactions.tsx